import { Box, Skeleton, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';

export default function BusinessProfileLoader() {
  const theme = useTheme();

  return (
    <Box p={{ xs: 2, lg: 3 }}>
      {/* Page Title */}
      <Skeleton variant='text' width={240} height={40} sx={{ mb: 3 }} />

      <Grid container spacing={3}>
        {/* Left Column - General Information */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Box bgcolor={theme.palette.background.paper} p={{ xs: 2, lg: 3 }} borderRadius='10px'>
            {/* Section Title */}
            <Skeleton variant='text' width={200} height={28} sx={{ mb: 3 }} />

            {/* Business Logo */}
            <Box display='flex' alignItems='center' gap={2} mb={3}>
              <Skeleton variant='circular' width={48} height={48} />
              <Skeleton variant='rectangular' width={120} height={36} sx={{ borderRadius: 1 }} />
            </Box>

            {/* Input Fields */}
            {[1, 2, 3, 4].map((idx) => (
              <Skeleton key={idx} variant='rectangular' width='100%' height={48} sx={{ borderRadius: 1, mb: 2 }} />
            ))}
          </Box>
        </Grid>

        {/* Right Column - Business Address */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Box bgcolor={theme.palette.background.paper} p={{ xs: 2, lg: 3 }} borderRadius='10px'>
            {/* Section Title */}
            <Skeleton variant='text' width={200} height={28} sx={{ mb: 3 }} />

            {/* Input Fields */}
            {[1, 2, 3, 4, 5].map((idx) => (
              <Skeleton key={idx} variant='rectangular' width='100%' height={48} sx={{ borderRadius: 1, mb: 2 }} />
            ))}
          </Box>
        </Grid>
      </Grid>

      {/* Update Button */}
      <Box display='flex' justifyContent={{ xs: 'stretch', md: 'flex-end' }} mt={3}>
        <Skeleton variant='rectangular' height={40} sx={{ borderRadius: 2, width: { xs: '100%', md: 120 } }} />
      </Box>
    </Box>
  );
}
